module.exports = __webpack_public_path__ + "img/login-register-logo.77f9f4c5.svg";